<script setup>
import DocumentGroupTable from '@frontJs/components/tables/projectManagement/DocumentGroupTable.vue';
import TenantFaqTable from '@frontJs/components/tables/projectManagement/tenantReports/TenantFaqTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import DocumentData from '@frontJs/partials/projectManagement/DocumentData.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Doc & FAQ - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Doc & FAQ </PageTitle>

    <TabLayout
        :tabs="{
            documents: {
                title: 'Documents',
                content: h(DocumentData),
            },
            documentGroups: {
                title: 'Groupes de documents',
                content: h(DocumentGroupTable),
            },
            faq: { title: 'FAQ', content: h(TenantFaqTable) },
        }"
    />
</template>
